/* eslint-disable max-lines */
import {
  REACT_APP_API_URL,
  REACT_APP_API_URL_MASTER,
  REACT_APP_API_URL_UNIFIED,
  REACT_APP_API_URL_INPUT_SOURCE,
  REACT_APP_API_PAYOUT_URL,
  REACT_APP_API_URL_REPORT_MANAGEMENT,
  REACT_APP_API_URL_CLAWBACK,
  REACT_APP_API_URL_GRID_APPROVAL_WORKFLOW,
} from 'config';

const dashboard = 'dashboard';
const upload = 'upload';
const incentiveProgram = 'incentive_program';
const organization = 'organization';
const fileUploadBaseUrl = `${REACT_APP_API_URL}/file_upload`;
const fileUpload = 'file_upload';
const downloadFileBaseUrl = `${REACT_APP_API_URL_MASTER}/download_file`;
const downloadUnifiedFile = `${REACT_APP_API_URL_UNIFIED}/download_unified_data_file`;
const userEvalPermissionDetails = 'user_eval_permission_details';
const frequency = 'frequency';
const workflow = 'workflow';
const program = 'program_configuration';
const updateUserLanguage = 'update_user_language';
const programConfigDetails = 'program_config_details';
const inputSourceConnection = 'input_source_connections';
const masterSourceConnection = 'master_data_source_connections';
const payoutInitiationStatus = 'unification_run_master';
const inputFileDownload = `${REACT_APP_API_URL_INPUT_SOURCE}/download_data`;
const inputFIleDownloads = `${REACT_APP_API_URL_INPUT_SOURCE}/download-unification-input-data`;
const masterFileDownload = `${REACT_APP_API_URL_INPUT_SOURCE}/download_data`;
const unificationDownload = `${REACT_APP_API_URL_INPUT_SOURCE}/download_data`;
const paymentManagement = `${REACT_APP_API_PAYOUT_URL}`;
const startCalculation = 'start_calculation';
const getTaskList = 'get_task_list';
const myTask = 'my_task';
const getTaskInstance = 'get_task_instance';
const getWorkflowWiseUnificationStatus = 'get_workflow_wise_unification_status';
const paymentProcess = 'payment_process';
const deletePaymentProcess = 'delete_payment_process';
const userRoles = 'get_user_roles_program_details';
const updateUserRoleProgramDetails = 'update_user_role_program_details';
const unificationRunStatus = 'unification_run_master';
const unificationRunMaster = 'unification_run_master';
const unificationHistoryTree = 'get_unified_making_structure';
const payoutLedger = 'get_payout_ledger_list';
const amounthWithdrawal = 'withdraw_payout_amount';
const dataSourceColumnList = 'data_source_column_list';
const graphDetails = 'graph_details';
const getIprogramWiseCalculationsStatus =
  'get_iprogram_wise_calculations_status';
const programWorkflowDetails = 'program_workflow_details';
const getCollectionPayoutDetails = 'get_collection_payout_details';
const getPaymentPartyUserCounts = 'get_payment_party_user_counts';
const getRuleDetailsCount = 'get_rule_details_count';
const getDataSyncDetails = 'get_data_sync_details';
const getMinimumMaximumPayoutDetails = 'get_minimum_maximum_payout_details';
const getPayoutApprovalTaskList = 'get_payout_approval_task_list';
const bulkUpdateTask = 'bulk_update_task';
const getTaskType = 'get_task_type';
const getPayoutReviewDetails = 'get_payout_review_details';
const getPayoutReviewCountDetails = 'get_payout_review_count_details';
const getReportingPayoutList = 'get_reporting_payout_variable_details';
const getProgramSimulationDetails = 'get_program_simulation_details';
const simulationMappingDetails = 'simulation_configuration_mapping_details';
const saveSimulationDetails = 'save_simulation_details';
const saveSimulationTaskConfig = 'simulation_task_configuration';
const getSimulationTaskList = 'simulated_task_list';
const getSimulationSummaryDetails = 'simulated_task_summary';
const getElasticSearchFields = 'get_elastic_search_fields';
const simulatedTaskDetails = 'simulated_task_details';
const getSimulationCalcDetails = 'simulation_calculation_details';
const getTaskListDetails = 'get_task_list_details';
const rules = 'rules';
const getAutoSyncSourceHistory = 'get_auto_sync_source_history';
const getSourceDataFileDetails = 'auto_sync_upload_file_details';
const getTaskTimelineDetails = 'get_task_timeline_details';
const paymentProcessTimeline = 'get_payment_process_timeline_details';
const getTaskDetails = 'get_task_details';
const getTaskDetailsFilterData = 'get_task_details_filter_data';
const getAllRecordById = 'get_all_records';
const getPaymentProcessDetails = 'get_payment_process_details';
const getAllfilters = 'get_all_filters';
const getTaskSummary = 'get_task_summary';
const downloadInvoice = `${REACT_APP_API_URL_REPORT_MANAGEMENT}/download_invoice`;
const createOrUpdateInvoice = 'create_or_update_invoice';

const invoice = 'invoice';
const updateTask = 'update_task';
const targetSetting = 'target_setting';
const targetConfiguration = 'target_configuration';
const getProgramRoles = 'get_program_roles';
const retryWorkflowTrigger = 'retry_workflow_trigger';
const retryUnification = 'retry_unification';
const getQueryJson = 'get_payout_formula_json';
const targetOverride = 'target_override';
const overriddenTarget = 'overridden_target';
const getAttributeWiseData = 'get_attribute_wise_data';
const getHistorialRulePlanIds = 'get-rule-plan-ids';
const userDetails = 'user_details';
const getTargetActualData = 'get_target_actual_data';
const getTargetActualLastData = 'get_target_actual_last_data';
const targetFrequency = 'target_frequency';
const getManualAdjustment = 'manual-adjustments';
const saveManualAdjustment = 'manual-adjustments';
const queryByTask = 'query-by-task';
const raiseQuery = 'raise-query';
const replyToQuery = 'reply-to-query';
const queryTaskList = 'query-task-list';
const closeQuery = 'close-query';
const getProgramBasedUserList = 'get_program_based_user_list';
const checkAdjsutmentsValidations = 'check-adjsutments-validations';
const getQueriedContracts = 'get-queried-contracts';
// const cancellationRecordsList = 'cancellation_records';
const cancellationRecordsList = 'contract-cancellation-upload';
// const cancellationRecords = `${REACT_APP_API_URL_CLAWBACK}/cancellation_records`;
const cancellationRecords = `${REACT_APP_API_URL_CLAWBACK}/contract-cancellation-upload`;
const inputSourceConnections = `input_source_connections`;
// const downloadCancellationTemplate = `${REACT_APP_API_URL_CLAWBACK}/download_cancellation_template`;
const downloadCancellationTemplate = `${REACT_APP_API_URL_CLAWBACK}/contract-cancellation-template`;
const downloadCancelledContract = `${REACT_APP_API_URL_CLAWBACK}/contract-cancellation-upload`;
const rulePlanUnifiedMapping = 'rule_plan_unified_mapping';
const performanceTargetFrequency = 'get_target_frequency';
const getTargetValues = 'get_target_parameters';
const getTargetTierData = 'get_target_tier_data';
const getTargetOverviewData = 'get_overview_details';
const getTargetLeaderviewData = 'get_target_leaderboard_data';
const getInsightsData = 'get_insights_data';
const getTargetPeriod = 'get_target_period';
const getNumberOfReportees = 'get_reportees_count';
const getCalculationRanFrequency = 'get_utr_frequency';
const utrFileDirectDownload = `${REACT_APP_API_PAYOUT_URL}/utr_file_upload`;
const utrFileUpload = `utr_file_upload`;
const uploadedUtrFileDirectDownload = `${REACT_APP_API_PAYOUT_URL}/download_utr_file`;
const ndcDetails = 'ndc_details';
const getPayoutReportFrequency = 'get-active-frequencies';
const getPayoutReportHistory = 'get_payout_report_history';
const preparePayoutReport = 'prepare_payout_report';
const deletePayoutReport = 'delete_payout_report';
const downloadPayoutReport = `${REACT_APP_API_URL_REPORT_MANAGEMENT}/download_payout_report`;
const utrFileList = 'utr_file_list';
const payoutComparison = 'payout-comparison';
const topRules = 'top-rules';
const decisionData = 'decision-data';
const getProgramBasedUserNameList = 'get-program-based-user-name-list';
const getProgramWorkflowRoles = 'get-program-workflow-roles';
const getUsersRole = 'get-users-roles';
const changeAssignee = 'change-asignee';
const rulePlanTask = 'get_user_rule_plan_task_list';
const rulePlanDraft = 'all_rule_plan_draft';
// const rulesPlanDraft = 'rule_plan_draft';
const ruleGroupDraft = 'rule_group_draft';
// const rulePlanDraftList = 'rule_plan_draft';
const rulesDraft = 'rules_draft';
const ruleGroup = 'rule_group';
const rulesPlan = 'rule_plan';
const getDmnXmlString = 'get_dmn_xml_string';
const getOutputVariableList = 'get_output_variable_list';
const approveRulePlanDraft = 'approve_rule_plan_draft';
const getRulePlanTaskInstance = 'get_user_rule_plan_task_instance';
const getPaymentPartyWiseTargetValue = 'get_payment_party_wise_target_values';
const getCouponList = 'get_coupon_list';
const getCouponCategories = 'get_coupon_categories';
const getCouponsFilterList = 'get_coupons_filter_list';
const getCouponsHistory = 'coupons_history';
const balancePoints = 'balance_points';
const redeemCoupon = 'redeem_coupon';
const getProfileSection = 'get_profile_section';
const getEarningDetails = 'get_earning_details';
const getUserCountDetails = 'get_user_count_details';
const getUserList = 'get_user_list';
const payoutStatus = 'payout_status';
const getPeriodWiseUserCountDetails = 'get_period_wise_user_count_details';
const geySourceSyncDetails = 'get_source_sync_details';
const getRuleDetailsCountApi = 'get_rule_details_count';
const getGainersLoosersDistribution = 'get_gainers_loosers_distribution';
const pendingPayoutUserDetails = 'pending_payout_user_details';
const getGainersLoosersUser = 'get_gainers_loosers_user_list';
const rulePlanWisePayoutHistory = 'rule_plan_wise_payout_history';
const getCalculationRuleDetails = 'get_calculation_rule_details';
const getCalculationRuleList = 'get_calculation_rule_list';
const downloadPendingPayoutUserList = `${REACT_APP_API_PAYOUT_URL}/download_pending_payout_user_list`;
const holdReleaseConfiguration = 'hold_release_configuration';
const getHoldList = 'get_hold_list';
const getReleaseList = 'get_release_list';
const saveHoldDetails = 'save_hold_details';
const saveReleaseDetails = 'save_release_details';
const getRulePlanIds = 'get_rule_plan_ids';
const getTaskColumns = 'get_task_columns';
const getTaskCount = 'task-count';
const contestDraft = 'contest-draft';
const contest = 'contest';
const fetchContestRuleData = 'fetch-contest-rule-data';
const approveContestTask = 'approve-contest-draft';
const getUserContestTaskList = 'get-user-contest-task-list';
const getApprovedContests = 'get-approved-contests';
const runContest = 'run-contest';
const contestStatus = 'contest-status';
const cancelContest = 'cancel-contest';
const teamPerformanceDashbaordInsights = 'insights/gainers-and-fallers-insight';
const userPerformanceInsights = 'insights/user-performance-insight';
const payoutReviewerDashboardInsights =
  'insights/payout-review-dashboard-insight';
const sendManualNudge = 'send_manual_nudge';
const getNudgeData = 'get_nudges_data';
const getPaymentProcessPayoutTypes = 'get_payment_process_payout_types';
const getPendingPayoutTaskCount = 'get_pending_payout_task_count';
const getTaskWorkflowStatus = 'get_task_workflow_status';
const clawbackRulePlans = 'clawback-rule-plans';
const clawbackTriggerFiles = 'clawback/trigger-files';
const triggerClawback = 'clawback/trigger';
const triggerClawbackList = 'clawback-process';
const clawbackProcess = 'clawback-process';
const userWallet = 'user_wallet';
const getUserBalance = 'get_user_balance';
const withdrawBalance = 'withdraw_payout_amount';
const reviewInProgress = 'review-in-progress';
const reviewSourceList = 'review-source-list';
const getFilterDataApproval = 'get_filter_data_approval';
const dataApprovalTask = 'data_approval_task';
const dataApprovalTaskFile = `${REACT_APP_API_URL_INPUT_SOURCE}/data_approval_task_file`;
const sendForApproval = 'send_for_Approval_workflow';
const getDiffDataReview = 'get-diff-data-review';
const diffSummary = `data-correction/diff-summary`;
const confirmDataCorrectionSync = `confirm_data_correction_sync`;
const resetDataCorrectionFile = 'reset_data_correction_file';
const getUnifiedSourceList = 'get_unified_source_list';

const reviewStart = 'review-start';
const downloadBulkAdjustmentTemplate = `${REACT_APP_API_PAYOUT_URL}/download_bulk_adjustment_template`;
const downloadBulkAdjustmentResult = `${REACT_APP_API_PAYOUT_URL}/download_bulk_adjustment_result`;
const getUploadedAdjustmentFiles = 'get_uploaded_adjustment_files';
const uploadBulkAdjustment = `${REACT_APP_API_PAYOUT_URL}/upload_bulk_adjustment`;
const simulationRulePlanWiseTabs = 'rule_plan_wise_tabs';
const vendors = 'vendors';
const invoiceDetails = 'invoice-details';
const allTaskCount = 'get-all-task-count';
const getEarnings = 'get_earnings';
const activeQueries = 'get-active-queries';
const changeQueryType = 'change-query-type';
const approveQuery = 'approve-query';
const getmovementtimlinequery = 'get-movement-timeline';
const checkQueryApproverPermission = 'check-query-approver-permission';
const getPeriodWiseUserDetails = 'get_period_wise_user_details';
const gridApprovalWorkflow = 'get_draft_and_approved_grids';
const createGridQuery = 'create_grid_query';
const replyToGridQuery = 'reply_to_query';
const downloadGridQueryFile = `${REACT_APP_API_URL_GRID_APPROVAL_WORKFLOW}/download_grid_query_file`;
const getQueryByTask = 'get_query_by_task';
const sendForRecalculation = 'send-for-recalculation';
const roles = 'roles';
const getRecalculationData = 'get-recalculation-data';
const startRecalculation = 'start-recalculation';
const recalculationFileUpload = 'recalculation_file_upload';
const activeRulePlans = 'active-rule-plans';
const recalculationTransactionSources = 'recalculation_transaction_sources';
const recalculationTransactionDataDownloadBase = `${REACT_APP_API_URL}/recalculation_transaction_data_download`;
const recalculationFileUploadBase = `${REACT_APP_API_URL}/recalculation_file_upload`;
const getpayoutdoneuserlist = 'get_payout_done_user_list';

const apiEndpoint = {
  dashboard,
  upload,
  incentiveProgram,
  organization,
  fileUploadBaseUrl,
  downloadFileBaseUrl,
  userEvalPermissionDetails,
  frequency,
  workflow,
  program,
  updateUserLanguage,
  programConfigDetails,
  inputSourceConnection,
  masterSourceConnection,
  payoutInitiationStatus,
  fileUpload,
  downloadUnifiedFile,
  inputFileDownload,
  masterFileDownload,
  paymentManagement,
  startCalculation,
  getTaskList,
  myTask,
  getTaskInstance,
  getWorkflowWiseUnificationStatus,
  paymentProcess,
  deletePaymentProcess,
  userRoles,
  updateUserRoleProgramDetails,
  unificationRunStatus,
  unificationHistoryTree,
  unificationDownload,
  payoutLedger,
  amounthWithdrawal,
  dataSourceColumnList,
  graphDetails,
  getIprogramWiseCalculationsStatus,
  programWorkflowDetails,
  getCollectionPayoutDetails,
  getPaymentPartyUserCounts,
  getRuleDetailsCount,
  getDataSyncDetails,
  getMinimumMaximumPayoutDetails,
  getPayoutApprovalTaskList,
  bulkUpdateTask,
  getTaskType,
  getPayoutReviewDetails,
  getPayoutReviewCountDetails,
  getReportingPayoutList,
  getProgramSimulationDetails,
  simulationMappingDetails,
  saveSimulationDetails,
  saveSimulationTaskConfig,
  getSimulationTaskList,
  getSimulationSummaryDetails,
  getElasticSearchFields,
  simulatedTaskDetails,
  getSimulationCalcDetails,
  getTaskListDetails,
  rules,
  getAutoSyncSourceHistory,
  getSourceDataFileDetails,
  getTaskTimelineDetails,
  paymentProcessTimeline,
  getTaskDetails,
  getAllRecordById,
  getPaymentProcessDetails,
  getAllfilters,
  getTaskSummary,
  downloadInvoice,
  invoice,
  updateTask,
  unificationRunMaster,
  targetSetting,
  targetConfiguration,
  getProgramRoles,
  retryWorkflowTrigger,
  retryUnification,
  getQueryJson,
  targetOverride,
  overriddenTarget,
  getAttributeWiseData,
  userDetails,
  getTargetActualData,
  getTargetActualLastData,
  targetFrequency,
  getManualAdjustment,
  saveManualAdjustment,
  queryByTask,
  raiseQuery,
  getProgramBasedUserList,
  replyToQuery,
  queryTaskList,
  closeQuery,
  checkAdjsutmentsValidations,
  getQueriedContracts,
  cancellationRecords,
  downloadCancellationTemplate,
  cancellationRecordsList,
  rulePlanUnifiedMapping,
  performanceTargetFrequency,
  getTargetValues,
  getTargetTierData,
  getTargetOverviewData,
  getTargetLeaderviewData,
  getInsightsData,
  getTargetPeriod,
  getNumberOfReportees,
  getCalculationRanFrequency,
  getHistorialRulePlanIds,
  utrFileDirectDownload,
  utrFileUpload,
  uploadedUtrFileDirectDownload,
  ndcDetails,
  getPayoutReportFrequency,
  getPayoutReportHistory,
  preparePayoutReport,
  deletePayoutReport,
  downloadPayoutReport,
  utrFileList,
  payoutComparison,
  topRules,
  getProgramBasedUserNameList,
  getProgramWorkflowRoles,
  decisionData,
  getUsersRole,
  changeAssignee,
  rulePlanTask,
  rulePlanDraft,
  // rulesPlanDraft,
  ruleGroupDraft,
  // rulePlanDraftList,
  rulesDraft,
  ruleGroup,
  rulesPlan,
  getDmnXmlString,
  getOutputVariableList,
  approveRulePlanDraft,
  getRulePlanTaskInstance,
  getPaymentPartyWiseTargetValue,
  getCouponList,
  getCouponCategories,
  getCouponsFilterList,
  getCouponsHistory,
  balancePoints,
  redeemCoupon,
  getProfileSection,
  getEarningDetails,
  getUserCountDetails,
  getUserList,
  payoutStatus,
  getPeriodWiseUserCountDetails,
  geySourceSyncDetails,
  getRuleDetailsCountApi,
  getGainersLoosersDistribution,
  pendingPayoutUserDetails,
  getGainersLoosersUser,
  rulePlanWisePayoutHistory,
  getCalculationRuleDetails,
  getCalculationRuleList,
  downloadPendingPayoutUserList,
  holdReleaseConfiguration,
  getHoldList,
  getReleaseList,
  saveHoldDetails,
  saveReleaseDetails,
  getRulePlanIds,
  getTaskColumns,
  getTaskCount,
  contestDraft,
  contest,
  fetchContestRuleData,
  approveContestTask,
  getUserContestTaskList,
  getApprovedContests,
  runContest,
  contestStatus,
  cancelContest,
  teamPerformanceDashbaordInsights,
  userPerformanceInsights,
  payoutReviewerDashboardInsights,
  sendManualNudge,
  getNudgeData,
  getPaymentProcessPayoutTypes,
  getTaskDetailsFilterData,
  getPendingPayoutTaskCount,
  getTaskWorkflowStatus,
  inputFIleDownloads,
  clawbackRulePlans,
  clawbackTriggerFiles,
  triggerClawback,
  triggerClawbackList,
  downloadCancelledContract,
  inputSourceConnections,
  clawbackProcess,
  userWallet,
  getUserBalance,
  withdrawBalance,
  reviewInProgress,
  reviewSourceList,
  dataApprovalTaskFile,
  getFilterDataApproval,
  dataApprovalTask,
  reviewStart,
  sendForApproval,
  getDiffDataReview,
  diffSummary,
  confirmDataCorrectionSync,
  resetDataCorrectionFile,
  getUnifiedSourceList,
  downloadBulkAdjustmentTemplate,
  downloadBulkAdjustmentResult,
  getUploadedAdjustmentFiles,
  uploadBulkAdjustment,
  simulationRulePlanWiseTabs,
  vendors,
  createOrUpdateInvoice,
  invoiceDetails,
  allTaskCount,
  getEarnings,
  activeQueries,
  changeQueryType,
  approveQuery,
  getmovementtimlinequery,
  checkQueryApproverPermission,
  getPeriodWiseUserDetails,
  gridApprovalWorkflow,
  createGridQuery,
  replyToGridQuery,
  downloadGridQueryFile,
  getQueryByTask,
  sendForRecalculation,
  roles,
  getRecalculationData,
  startRecalculation,
  recalculationFileUpload,
  activeRulePlans,
  recalculationTransactionSources,
  recalculationTransactionDataDownloadBase,
  recalculationFileUploadBase,
  getpayoutdoneuserlist,
};

export default apiEndpoint;
